import type { TMapTagSizeToViewTextV2 } from './models';

// В десктопной и мобильной версиях раньше использовался `deprecated-text`
// и у него для размеров "xs" | "s" | "m" | "l" был разный размер шрифтов
// Данный конфиг соотносит пропс `size` тегов -> `size` у deprecated-text -> с пропсом `view` у text-v2;

// Desktop
// xs: 12 - secondaryNormal - secondary-medium,
// s: 14 - primarySmall - primary-small,
// m: 16 - primaryNormal - primary-medium,
// l: 18 - primaryLarge - primary-large,

export const mapTagSizeToViewTextV2Desktop: TMapTagSizeToViewTextV2 = {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    xxs: 'primary-small',
    xs: 'primary-small',
    s: 'primary-small',
    m: 'primary-medium',
    l: 'primary-large',
};

// Mobile
// xs: 12 - secondaryNormal - secondary-medium,
// s: 13 - secondaryLarge - secondary-large,
// m: 14 - primarySmall - primary-small,
// l: 16 - primaryNormal - primary-medium,

export const mapTagSizeToViewTextMobile: TMapTagSizeToViewTextV2 = {
    xxs: 'primary-small',
    xs: 'secondary-medium',
    s: 'secondary-large',
    m: 'primary-small',
    l: 'primary-medium',
};
